import { render, staticRenderFns } from "./NoteCandidateDialog.vue?vue&type=template&id=3b6ba3d1&scoped=true"
import script from "./NoteCandidateDialog.vue?vue&type=script&lang=js"
export * from "./NoteCandidateDialog.vue?vue&type=script&lang=js"
import style0 from "./NoteCandidateDialog.vue?vue&type=style&index=0&id=3b6ba3d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6ba3d1",
  null
  
)

export default component.exports